import { cookieSections } from "../../../content/legal";
import { PolicySectionList } from "../../legal/PolicySectionList";
import { PageTemplate } from "../../templates/PageTemplate";

export function CookiesPage() {
  return (
    <PageTemplate
      id="cookies-page"
      header={{
        kicker: "Cookies and Storage",
        title: "Storage technologies and diagnostics",
        description:
          "This page describes the local storage, IndexedDB, and optional diagnostics mechanisms used by the current app build.",
      }}
    >
      <PolicySectionList sections={cookieSections} />
    </PageTemplate>
  );
}
